import React, { ChangeEvent, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';
import { IBaseInput } from '~/sharedInterfaces/SharedInterfaces';
import { getDefaultLabelName } from '~/services/DefaultLabelNameService';
import { IState } from '~/sharedInterfaces/IState';
import ComponentError from '../../ComponentError/ComponentError';
import { getInputClassNames, hashCode } from '~/utils';
import { logUserFirstInteraction } from '~/actions/widgetContextActions';
import Tooltip from '../Tooltip/Tooltip';

export interface ITextAreaProps extends IBaseComponent, IBaseInput {
  value: string;
}

const TextArea: FC<ITextAreaProps> = ({
  componentName,
  label,
  value,
  onChange,
  error,
  placeholder,
  tooltip,
}) => {
  const { locale, settings } = useSelector((state: IState) => state.widgetContext);
  const componentLabel = label || getDefaultLabelName(locale, componentName).label;
  const componentTooltipText = getDefaultLabelName(locale, componentName).tooltipText;
  const uniqueKey = hashCode(`${settings.id}${componentName}`);
  const dispatch = useDispatch();

  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) onChange(event);

    dispatch(logUserFirstInteraction());
  };

  return (
    <div
      className={getInputClassNames({
        tooltip,
        error,
        componentName,
        additionalClassName: 'qred-textfield',
      })}
    >
      {componentTooltipText && <Tooltip tooltip={tooltip} tooltipText={componentTooltipText} />}
      <div className="qred-group">
        <div className="qred-row">
          <label htmlFor={uniqueKey}>
            <span className="qred-first">{componentLabel}</span>
          </label>
          <textarea
            name={uniqueKey}
            id={uniqueKey}
            value={value}
            onChange={handleOnChange}
            placeholder={placeholder}
          />
          {error && <ComponentError error={error} />}
        </div>
      </div>
    </div>
  );
};

export default TextArea;
